<!--
 * @Description:
 * @Author: seam
 * @Date: 2021-08-24 16:19:56
 * @LastEditors: seam
 * @LastEditTime: 2021-09-01 15:55:31
 * @FilePath: \layer-client\src\view\case\plugins\caseMajor.vue
-->
<template>
  <Poptip trigger="hover" word-wrap width="200" content="content" placement="bottom" class="pop-tip" transfer>
    <span class="major-level">{{ level }}</span>
    <div slot="content" class="major-content">
      <div v-if="ifLawyer"><span class="major-title">推荐律师：</span>{{ row.recommendLawyerName }}</div>
      <div>
        <span class="major-title" style="color: #909090;">重案原因：</span>{{ row.reason }}
      </div>
      <!-- <span v-if="ifAct&&!['A','B','C','D'].includes(level)" style="color: #3a5bae;cursor: pointer;" class="fix-info" @click="fixMajorInfo">补充重案信息</span> -->
    </div>
  </Poptip>
</template>

<script>
export default {
  props: {
    ifLawyer: {
      type: Boolean,
      default: false
    },
    ifAct: { // 是否需要操作
      type: Boolean,
      default: false
    },
    level: {
      type: String,
      default: ''
    },
    row: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      key: 111
    }
  },
  methods: {
    fixMajorInfo() {
      this.$emit('addInfo')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/globalStyle.scss';
.pop-tip{
  .major-level{
    display:block;
    margin-left:4px;
    margin-top: 5px;
    width:24px;
    height:25px;
    background-repeat: no-repeat;
    background-size: 100%;
    color:#fff;
    text-align:center;
    background-image: url(../../../assets/images/mark-major.png);
    cursor:pointer;
  }
  .major-content{
    color:#333;
  }
  .major-title{
    color:$labelColor;
  }
  .fix-info{
    color:$globalMainColor;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/case/plugins/caseMajor.vue